import {MultiLanguageObject} from "@api/models/objects/MultiLanguageObject";
import {Event} from "@api/models/Event";

export class PartnerIdsChangedObserver {
    constructor(
        private readonly event: MultiLanguageObject<Event>
    ) { }

    handle(partnerId: string) {
        if (!this.event.base) { return; }

        if (!this.event.base?.partnerIds) {
            this.event.base.partnerIds = [];
        }

        const partnerIndex = this.event.base.partnerIds.indexOf(partnerId);

        if (partnerIndex >= 0) {
            this.event.base.partnerIds.splice(partnerIndex, 1);
        }
        else {
            this.event.base.partnerIds.push(partnerId);
        }
    }
}
